import type { MembershipRole } from "@safeplate/contracts";
import { Navigate, useRouterState } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { accessRedirect } from "./navigation.js";

// Pages a role may not open send it back to Today (or Settings) without a message.
export function RoleGate({
  children,
  role,
}: {
  children: ReactNode;
  role: MembershipRole;
}) {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });
  const redirectTo = accessRedirect(role, pathname);
  if (redirectTo) return <Navigate replace to={redirectTo} />;
  return children;
}
